<template>
    <div class="profile-single">
        <ProfileSingleEdit v-if="isEdit" :subProfile="subProfile" @editToggle="editToggle"></ProfileSingleEdit>
        <ProfileSingleData v-else :subProfile="subProfile" @editToggle="editToggle"></ProfileSingleData>
    </div>
</template>

<script>
import ProfileSingleData from "./ProfileSingleData.vue"
import ProfileSingleEdit from "./ProfileSingleEdit.vue"

export default {
    name: "AccountProfileSingle",
    components: {
        ProfileSingleData,
        ProfileSingleEdit
    },
    props: {
        subProfile: {
            type: Object
        }
    },
    data() {
        return {
            isEdit: false
        };
    },
    methods: {
        editToggle() {
            this.isEdit = !this.isEdit;
        }
    }
};
</script>